export const saveScrollPosition = () => {
  const scrollPosition = window.pageYOffset || document.documentElement?.clientTop;
  window.history.replaceState({ scrollPosition }, '');
};

export const scrollToSavedPosition = () => {
  const scrollPosition = window.history?.state?.scrollPosition;
  if (scrollPosition) {
    setTimeout(() => {
      window.scrollTo(0, scrollPosition);
    });
  }
};
